"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleFile = void 0;
const constants_1 = require("./constants");
const utilities_1 = require("./utilities");
class LocaleFile {
    constructor() {
        this._resources = {};
        this._resources[constants_1.Constants.$Schema] = constants_1.Constants.MosManifestLocalizationSchemaVersionGA;
    }
    addResource(key, value) {
        utilities_1.Utilities.assert(utilities_1.Utilities.isNullOrUndefined(this._resources[key]), "resource should not already have been added");
        this._resources[key] = value;
    }
    getResources() {
        return this._resources;
    }
}
exports.LocaleFile = LocaleFile;
//# sourceMappingURL=localeFile.js.map